import type React from 'react';
import { useId } from 'react';
import type { IconProps } from './icon-props';

export function createIcon(displayName: string, paths: React.ReactNode): React.FC<IconProps> {
  const Icon: React.FC<IconProps> = ({ size = 24, color = 'currentColor', title, ...rest }) => {
    const titleId = useId();
    const hasTitle = title != null;

    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden={hasTitle ? undefined : true}
        role={hasTitle ? 'img' : undefined}
        aria-labelledby={hasTitle ? titleId : undefined}
        {...rest}
      >
        {hasTitle && <title id={titleId}>{title}</title>}
        {paths}
      </svg>
    );
  };
  Icon.displayName = displayName;
  return Icon;
}
